/* Floating contact button — scheduled WhatsApp / Shopify Inbox toggle.

   Why client-side: the storefront is full-page cached, so a server-side (Liquid)
   time check would freeze into the cached HTML and be wrong for later visitors.
   Liquid emits a static schedule in #fcb-config; this script decides visibility at
   runtime in the visitor's browser and re-checks every minute so it flips at the
   hour boundary without a reload.

   Fail-safe: on any error (bad config, unsupported Intl, invalid selector) we leave
   the Shopify Inbox button as-is and keep WhatsApp hidden — never zero buttons. */
(function () {
  "use strict";

  var CONFIG_ID = "fcb-config";
  var ACTIVE_CLASS = "fcb-whatsapp-active";
  var CHECK_INTERVAL_MS = 60000;
  var DOW = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    var cfg = JSON.parse(el.textContent);
    return cfg && cfg.schedule ? cfg : null;
  }

  // Current weekday (0=Sun..6=Sat) and minutes-since-midnight in the given IANA zone,
  // independent of the visitor's own timezone. Intl handles PST/PDT automatically.
  function nowInZone(timeZone) {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    var map = {};
    for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;

    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0; // some engines emit "24" at midnight with hour12:false
    var minute = parseInt(map.minute, 10);
    return { dow: DOW[map.weekday], minutes: hour * 60 + minute };
  }

  function isWhatsAppTime(cfg) {
    var t = nowInZone(cfg.timeZone || "America/Los_Angeles");
    var day = cfg.schedule[String(t.dow)];
    if (!day || !day.enabled) return false;

    var start = parseInt(day.start, 10);
    var end = parseInt(day.end, 10);
    if (isNaN(start) || isNaN(end)) return false;

    var m = t.minutes;
    if (end > start) return m >= start && m < end; // normal window, end exclusive (17:00 -> Inbox)
    if (end < start) return m >= start || m < end; // overnight wrap
    return false; // start === end -> treated as closed
  }

  function inboxNodes(selector) {
    if (!selector) return [];
    try {
      return document.querySelectorAll(selector);
    } catch (e) {
      return []; // invalid selector -> fail safe (Inbox stays visible)
    }
  }

  function hideInbox(selector) {
    var nodes = inboxNodes(selector);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty("display", "none", "important");
    }
    return nodes.length > 0;
  }

  function showInbox(selector) {
    var nodes = inboxNodes(selector);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.removeProperty("display");
    }
  }

  var observer = null;

  function stopWatching() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  // The Inbox widget loads asynchronously and may set its own inline display.
  // The pre-existing CSS rule hides it on insertion; this observer is a fallback
  // that re-applies an inline override, then disconnects (or times out at 10s).
  function watchForInbox(selector) {
    if (hideInbox(selector) || observer || !("MutationObserver" in window) || !selector) return;
    observer = new MutationObserver(function () {
      if (hideInbox(selector)) stopWatching();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(stopWatching, 10000);
  }

  function applyState(cfg, isWa) {
    document.documentElement.classList.toggle(ACTIVE_CLASS, isWa);
    if (isWa) {
      watchForInbox(cfg.inboxSelector);
    } else {
      stopWatching();
      showInbox(cfg.inboxSelector);
    }
  }

  function init() {
    var cfg;
    try {
      cfg = readConfig();
    } catch (e) {
      return; // malformed config -> fail safe
    }
    if (!cfg) return;

    function recheck() {
      try {
        applyState(cfg, isWhatsAppTime(cfg));
      } catch (e) {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        stopWatching();
        showInbox(cfg.inboxSelector);
      }
    }

    recheck();
    window.setInterval(recheck, CHECK_INTERVAL_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
